import { render } from "./AlertMobile.vue?vue&type=template&id=20699487&scoped=true"
import script from "./AlertMobile.vue?vue&type=script&lang=js"
export * from "./AlertMobile.vue?vue&type=script&lang=js"

import "./AlertMobile.vue?vue&type=style&index=0&id=20699487&scoped=true&lang=css"
import "@/styles/header.css?vue&type=style&index=1&id=20699487&scoped=true&lang=css&external"
import "@/styles/common.css?vue&type=style&index=2&id=20699487&scoped=true&lang=css&external"
import "@/styles/subcommon.css?vue&type=style&index=3&id=20699487&scoped=true&lang=css&external"

import exportComponent from "../../../../../../../Users/cole/Desktop/중요/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20699487"]])

export default __exports__